import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteMensagem() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/mensagem/${id}`);
    },
    { retry: false }
  );
}

export default useDeleteMensagem;
